<!-- @format -->
<binding-tag>
    <slot/>
    <script>
        import debounce from 'debounce-promise';
        import di from "dependency-injection";
        import basicInformation from "@model/basicInformation/api";

        export default {
            basicInformation: basicInformation,
            input: null,
            initialize(flag = true) {
                let checkbox = flag & (this.root.type === 'checkbox')
                if ((this.root.tagName === 'INPUT' && this.root.type === 'text') ||
                    this.root.tagName === 'TEXTAREA'
                ) {
                    this.root.value = this.basicInformation.item[this.props.name] || ''
                } else if (checkbox || this.root.type === 'radio') {
                    let val = this.root.getAttribute('val')
                    if (val == this.basicInformation.item[this.props.name]) {
                        this.root.checked = true
                    }
                } else if (this.root.tagName === 'SELECT') {
                    for (let idx = 0; idx < this.root.options.length; idx++) {
                        if (this.root.options[idx].value == this.basicInformation.item[this.props.name]) {
                            this.root.options[idx].selected = true;
                        } else {
                            this.root.options[idx].selected = false;
                        }
                    }
                }
            },
            setValid(valid) {

                if (this.props.show_default_error === false) {
                    return false; //なにもしない。エラー周りの表示はコンポーネントに任せる
                }

                if (valid) {
                    this.root.classList.remove('is-error')
                    if (null !== this.root.parentElement) {
                        let errors = this.root.parentElement.getElementsByClassName('error')
                        for (let error of errors) {
                            this.root.parentElement.removeChild(error)
                        }
                    }
                } else {
                    if (null !== this.root.parentElement) {
                        if (!this.root.classList.contains('is-error')) {
                            this.root.classList.add('is-error')
                            const div = document.createElement('div')
                            div.textContent = this.props.errmsg
                            div.classList.add('error')
                            this.root.parentElement.appendChild(div)
                        }
                    }
                }
            },
            addEvent() {
                this.root.addEventListener('change', this.input)
                if ((this.root.tagName === 'INPUT' && this.root.type === 'text') ||
                    this.root.tagName === 'TEXTAREA'
                ) {
                    this.root.addEventListener('keyup', this.input)
                    this.root.addEventListener('paste', this.input)
                    this.root.addEventListener('blur', this.input)
                } else if (this.root.type === 'checkbox' || this.root.type === 'radio') {
                    this.root.addEventListener('sync', this.input)
                }
            },
            removeEvent() {
                this.root.removeEventListener('change', this.input)
                if ((this.root.tagName === 'INPUT' && this.root.type === 'text') ||
                    this.root.tagName === 'TEXTAREA'
                ) {
                    this.root.removeEventListener('keyup', this.input)
                    this.root.removeEventListener('paste', this.input)
                    this.root.removeEventListener('blur', this.input)
                } else if (this.root.type === 'checkbox' || this.root.type === 'radio') {
                    this.root.removeEventListener('sync', this.input)
                }
            },
            onMounted(props, state) {
                //入力オブジェクトへのvalidをdebounce()でまとめてthis.inputにいれておく。入力のたびに発火してほしくないため
                this.input = debounce((e) => {
                    let value = '';
                    if (this.root.type === 'checkbox' || this.root.type === 'radio') {
                        value = e.target.checked ? this.props.val : ''
                    } else if (this.root.tagName === 'SELECT') {
                        value = e.target.options[e.target.selectedIndex].value
                    } else {
                        value = e.target.value
                    }
                    let validation = this.basicInformation.getValidation(this.props.name)
                    let valid = this.basicInformation.item.set(this.props.name, value, validation)

                    //独自チェック
                    if (this.props.name === 'mynumber') {
                        valid = String(value).length === 12
                    } else if (this.props.name === 'zip') {
                        valid = String(value).length === 7
                    } else if (this.props.name === 'invoice_provider_number_body') {
                        //適格請求書発行事業者番号
                        this.props.using_valid_func(e)
                        valid = false
                    } else if (this.props.name === 'invoice_provider_state') {
                        this.props.change_func(e)
                        valid = false
                    }


                    this.setValid(valid)
                }, 100)

                this.addEvent()
                this.initialize(true)
            },
            onUnmounted(props, state) {
                this.removeEvent()
            },
            onUpdated(props, state) {
                this.initialize(false)
            },
        }
    </script>
</binding-tag>